import React, {useContext, useEffect} from 'react';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import SearchBox from '../common/SearchBoxComponent';
import {Button} from 'antd';
import LoginMethod from '../common/LoginMethod';
import {camelObj} from '../common/ConversionMethod';

export default function EssentialInformationAdmin() {
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/admin/api!organizationAndBranch.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const detailClick = (item) => {
		const baseUrl = '/base/essential-information';
		LoginMethod(camelObj(item), baseUrl);
	};

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '社会组织',
			dataIndex: 'organization_name',
		},
		{
			title: '党支部名称',
			dataIndex: 'branch_name',
		},
		{
			title: '成立时间',
			dataIndex: 'branch_establish_date',
			width: 120,
		},
		{
			title: '换届时间',
			dataIndex: 'branch_term_date',
			width: 120,
		},
		{
			title: '每届年限',
			dataIndex: 'branch_term_year',
			width: 120,
		},
		{
			title: '支部性质',
			dataIndex: 'branch_attribute',
			width: 100,
		},
		{
			title: '操作',
			width: 100,
			render: (item) => (
				<Button type="link" onClick={() => detailClick(item)}>查看</Button>
			),
		},
	];

	const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<SearchBox placeholder="请输入社会组织关键字"/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}

